import { Component, OnDestroy, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";

import { appStateProvider } from "../../insa-providers";
import { InsaService } from "../../insa-services";
import { NewsDataModel } from "../../insa-models";
import { appConfig } from "../../../insaweb.config";

@Component({
  selector: "insaweb-news",
  templateUrl: "news.component.html",
})
export class NewsComponent implements OnDestroy, AfterViewInit {
  private newsData: NewsDataModel[];
  private newsDataSubscription;

  constructor(
    private _insaService: InsaService,
    private _appStateProvider: appStateProvider,
    private _router: Router,
  ) {
    this.newsDataSubscription = this._insaService.NewsDataEvent.subscribe(
      (news) => {
        this.refreshNewsData(news);
      },
    );
  }

  private refreshNewsData(news: NewsDataModel[]) {
    if (news !== undefined && news.length > 0) {
      this.newsData = news;
      $("#newsMessage").html("");
      setTimeout(this.triggerRight.bind(this), 1000);
    } else {
      this.newsData = [];
      $("#newsMessage").html(
        "<div class='center no-data-message' style='display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;'>" +
          "<img src='../../images/nodata.svg' style='width:150px;height:150px'/>" +
          "<p style='overflow: hidden !important; padding: 0 !important; margin: 0 !important; min-height: 0 !important;'>NO DATA</p>" +
          "</div>",
      );
    }
  }
  private triggerRight() {
    if (
      this.newsData !== undefined &&
      this.newsData !== null &&
      this.newsData.length > 0
    ) {
      this.newsTextVisibility();
      let carouselOpt: CarouselOptions = {};
      carouselOpt.interval = appConfig.setCarouselTimeout;
      $("#carousel-generic").carousel(carouselOpt);
    }
  }

  private newsTextVisibility() {
    if (this._router.url === "/news") {
      $(".news").css("display", "block");
    } else if (this._router.url === "/home") {
      $(".news").css("display", "none");
    }
  }

  private isActive(news: any) {
    return news === this._insaService.newsData[0];
  }

  ngAfterViewInit() {
    kendo.ui.progress($(".news-loading"), this._appStateProvider.fetchingNews);
    this.refreshNewsData(this._insaService.newsData);
  }

  ngOnDestroy() {
    this.newsDataSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-news/news.component.ts